const apiConfig = {
    baseUrl: 'https://api.themoviedb.org/3/',
    apiKey: 'c578027419c5f31ca768c56b09aa4026',
    originalImage: (imgPath) => `https://image.tmdb.org/t/p/original/${imgPath}`,
    w500Image: (imgPath) => `https://image.tmdb.org/t/p/w500/${imgPath}`
};

export default apiConfig;
